import React, { Fragment } from "react";
import { withRouter, Link } from "react-router-dom";
import { MemoryRouter, Route } from "react-router";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { cartAdd } from "../../actions/cart";
import { Button, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { Drawer } from "@material-ui/core";
import "react-toastify/dist/ReactToastify.css";
import * as dropdowns from "../product/Dropdown";
import { generatePath } from "react-router";

import StarRatings from "react-star-ratings";
import ContentLoader from "react-content-loader";
import SingleProduct from "../../components/singleProductCard/singleProductCard";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { getBrandFilteredProduct } from "../../actions/filter";

import {
  CarouselProvider,
  DotGroup,
  ImageWithZoom,
  Slide,
  Slider,
} from "pure-react-carousel";
import { getGroups } from "../../actions/categories";
import "pure-react-carousel/dist/react-carousel.es.css";
import Parser from "html-react-parser";
import { sellerProducts } from "../../actions/products";
import { retreiveBrandBySlug } from "../../actions/brand";
//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
class BrandDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      link: "",
      parentModel: "",
      brandDetail: "",
      prevSlug: "",
      preSlugNo: "",
      products: "",
      brandInfo: "",
      storeInfo: "",
      dataPerPage: 40,
      currentPage: 1,
      show: false,
      quickView: [],
      images: [],
      quantity: 1,
      affirm: [],
      apiCall: false,
      loading: true,
      configuration: {},
      catagoryConfigurationDetails: [],
      groupCallFlag: false,
      groupLoading: true,
      configAttrId: [],
      selectedFilters: [],
      queryString: "",
      finalFilters: [],
      attrSelectedArr: [],
      groupFilters: [],
      count: 0,
      brandId: "",
      currentPage: 1,
    };
  }
  async componentDidMount() {
    window.scrollTo(0, 0);
    const page = this.state.currentPage;
    const slug = this.props.match.params.slug;
    const res = await this.props.retreiveBrandBySlug(slug, page);
    console.log(res);
    this.setState({
      // products: res.data[1][0].paginatedResults,
      products: res.data[0].products[0].paginatedResults,
      brandInfo: res.data[0].fullName,
      storeInfo: res.data[0].profile,
      configuration: res.data[0].configuration[0],
      groupFilters: res.data[0].groupFilters,
      brandId: res.data[0]._id,
    });

    if (this.state.groupFilters) {
      const tempFiltersFinal = [];

      this.state.groupFilters.map((item, index) => {
        const tempFilters = [];

        if (item.filters.length) {
          item.filters.map((item1) => {
            item1.brand.map((item2) => {
              if (this.state.brandId === item2.brandId) {
                if (item2.image) {
                  tempFilters.push({
                    title: item1.title,
                    image: item2.image,
                    imageFlag: true,
                  });
                } else {
                  tempFilters.push({
                    title: item1.title,
                    imageFlag: false,
                  });
                }
              }
            });
          });
          tempFiltersFinal.push({
            title: item.title,
            children: tempFilters,
          });
        }
      });
      const tempFiltersFinalFinal = [];
      tempFiltersFinal.map((item) => {
        const imageFilters = [];
        const nonImageFilters = [];
        item.children.map((item1) => {
          if (item1.imageFlag) {
            imageFilters.push(item1);
          } else {
            nonImageFilters.push(item1);
          }
        });
        tempFiltersFinalFinal.push({
          title: item.title,
          children: {
            imageFilters,
            nonImageFilters,
          },
        });
      });

      this.setState({ finalFilters: tempFiltersFinalFinal });
    }

    this.setState({
      count: res.data[0].products[0].totalCount[0].count,
    });

    if (this.state.configuration) {
      this.setState({
        catagoryConfigurationDetails: this.state.configuration
          .categoryConfiguration[0].categoryConfigurationDetail,
      });
    }
    this.setState({ loading: false });

    console.log(this.state.configuration);
    console.log(this.state.products);

    if (this.props.location.search) {
      let testerString = this.props.location.search.substring(1);

      let testerString1 = testerString.replaceAll("%20", " ");
      console.log(testerString1);

      let testerArray = testerString1.split("&");

      this.setState({
        selectedFilters: testerArray,
      });
      let attrArray = [];
      this.state.groupFilters.map((item) => {
        item.filters.map((item1) => {
          this.state.selectedFilters.map((item2) => {
            if (item1.title === item2) {
              attrArray.push(item1.selectedAttribute);
            }
          });
        });
      });
      this.setState({ attrSelectedArr: attrArray });
      const dataToSend = {
        slug: this.props.match.params.slug,
        filter: this.state.attrSelectedArr,
      };
      const Res = await this.props.getBrandFilteredProduct(
        JSON.stringify(dataToSend)
      );
      this.setState({
        products: Res[0].products[0].paginatedResults,
      });
      this.setState({
        count: Res[0].products[0].totalCount[0].count,
      });
      const currentState = await this.flagStateUpdater();
      console.log(currentState);
    }
    const test = await this.flagStateUpdater();
    console.log(test);

    // if (this.state.prevSlug !== slug) {
    //   window.scrollTo(0, 0);
    //   this.fetchData(slug);
    //   this.setState({ prevSlug: slug, preSlugNo: false });
    // }
  }
  // async componentDidUpdate(prevProps, prevState) {
  //   const slug = window.location.toString().split("brand/")[1];
  //   if (prevState.prevSlug !== slug) {
  //     window.scrollTo(0, 0);
  //     this.fetchData(slug);
  //     this.setState({ prevSlug: slug, preSlugNo: false });
  //   }
  // }

  _addToWishlist = async (item) => {
    const wishlistData = localStorage.getItem("wishlist");
    if (wishlistData && wishlistData.length > 0) {
      const arr = JSON.parse(wishlistData);
      var a = true;
      arr.forEach((e, index) => {
        if (e._id === item._id) {
          a = false;
          arr.splice(index, 1);
          toast(`Product removed from wishlist`, { containerId: "B" });
        }
      });
      if (a === true) {
        arr.push(item);
      }
      localStorage.setItem("wishlist", JSON.stringify(arr));
    } else {
      localStorage.setItem("wishlist", JSON.stringify([item]));
    }
    if (a !== false) {
      this.setState({ show: false });
      toast(`Product added to wishlist`, { containerId: "B" });
    }
  };
  productsLoader = (number) => {
    let table = [];

    for (let i = 0; i < number; i++) {
      table.push(
        <Fragment>
          {
            <ContentLoader
              speed={2}
              width={300}
              height={470}
              viewBox="0 0 300 470"
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb"
              className="col-md-3"
            >
              <rect x="4" y="35" rx="0" ry="0" width="291" height="256" />
              <rect x="4" y="309" rx="0" ry="0" width="276" height="52" />
              <rect x="4" y="372" rx="0" ry="0" width="104" height="27" />
              <rect x="7" y="445" rx="0" ry="0" width="142" height="20" />
              <circle cx="19" cy="421" r="14" />
              <circle cx="152" cy="422" r="14" />
              <circle cx="53" cy="421" r="14" />
              <circle cx="88" cy="422" r="14" />
              <circle cx="121" cy="421" r="14" />
            </ContentLoader>
          }
        </Fragment>
      );
    }
    return table;
  };
  _addToCart = async (item) => {
    // console.log(item);

    const data = {
      item: item,
      quantity: this.state.quantity,
    };
    const cartAdd = await this.props.cartAdd(data);
    if (cartAdd) {
      this.setState({
        show: false,
        quantity: 1,
      });
      toast(`Product added in cart`, { containerId: "B" });
    }
  };
  flagStateUpdater = async (index) => {
    console.log(index);
    const idArr = [];

    this.state.products.map((item) => {
      if (item.groupedItem) {
        idArr.push(item._id);
      }
    });
    if (this.state.groupCallFlag === false) {
      const configattrr = [];
      this.state.configuration &&
        this.state.configuration.categoryConfiguration[0].categoryConfigurationDetail.map(
          (item) => configattrr.push(item.keyFieldId)
        );

      this.setState({ groupCallFlag: true });
      const dataTosend = {
        ids: idArr,
        attributes: configattrr,
      };

      const Res = await this.props.getGroups(JSON.stringify(dataTosend));
      console.log(Res);
      console.log(this.state.groupCallFlag);
      const newData = this.state.products;
      if (Res.data.data !== 0) {
        this.state.products.map((item, index) => {
          Res.data.map((item1) => {
            if (item._id === item1._id) {
              newData[index] = {
                ...item,
                grouping: item1.grouping,
                count: item1.count,
              };
            }
          });
          console.log(newData);
        });
      }
      this.setState({ products: newData });
      console.log(this.state.products);
      this.setState({ groupLoading: false });
    }
  };

  handleSelectedFilters = (event, SelectedFilter) => {
    this.setState(
      {
        selectedFilters: SelectedFilter,
      },
      function () {
        let attrArray = [];
        this.state.groupFilters.map((item) => {
          item.filters.map((item1) => {
            this.state.selectedFilters.map((item2) => {
              if (item1.title === item2) {
                attrArray.push(item1.selectedAttribute);
              }
            });
          });
        });
        this.setState({ attrSelectedArr: attrArray }, function () {
          console.log(this.state.attrSelectedArr);
          this.setState(
            {
              queryString: this.state.selectedFilters.join("&"),
            },
            async function () {
              this.props.history.push({
                search: `${this.state.queryString}`,
              });
              const dataToSend = {
                slug: this.props.match.params.slug,
                filter: this.state.attrSelectedArr,
              };
              this.setState({ loading: true });
              this.setState({ groupCallFlag: false });

              const Res = await this.props.getBrandFilteredProduct(
                JSON.stringify(dataToSend)
              );
              this.setState(
                {
                  products: Res[0].products[0].paginatedResults,
                },
                async function () {
                  this.setState({
                    count: Res[0].products[0].totalCount[0].count,
                  });
                  console.log(this.state.products);
                  const currentState = await this.flagStateUpdater();
                  console.log(currentState);
                  console.log(Res);
                  this.setState({ loading: false });
                }
              );
            }
          );
        });
      }
    );
  };

  handleClose = () => {
    this.setState({ show: false, quantity: 1 });
  };
  handleShow = () => {
    this.setState({ show: true, quantity: 1 });
  };

  toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.type === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ rightSidebar: open });
  };

  _openModal = async (e, item) => {
    e.preventDefault();
    const productsArr = [];
    // item &&
    //   item.forEach(async __element => {
    //     productsArr.push(__element);
    //   });
    // console.log("product array ", item);
    await this.setState({ quickView: item });
    const images = [];
    item.images.forEach((e) => {
      images.push({
        original: e,
        thumbnail: e,
      });
    });
    this.setState({ images: images });

    this.setState({ show: true });
  };
  handleClick = (event) => {
    console.log(this.state.attrSelectedArr);
    this.setState(
      {
        currentPage: Number(event.page),
      },
      async () => {
        if (this.props.location.search.length !== 0) {
          if (this.state.filterPageFlag) {
            this.setState({
              currentPage: 1,
              filterPageFlag: false,
            });
          }
          this.props.history.push({
            pathname: generatePath(this.props.match.path, {
              slug: this.props.match.params.slug,
              page: this.state.currentPage,
            }),
          });
          this.props.history.push({
            search: `${this.state.queryString}`,
          });
          const dataToSend = {
            slug: this.props.match.params.slug,
            filter: this.state.attrSelectedArr,
            page: this.state.currentPage,
          };
          this.setState({ loading: true });
          this.setState({ groupCallFlag: false });

          const Res = await this.props.getFilteredProduct(
            JSON.stringify(dataToSend)
          );
          const test = await this.flagStateUpdater();

          this.setState({
            configuration: this.state.subCategory.configuration[0],
          });
          if (this.state.configuration) {
            this.setState({
              catagoryConfigurationDetails: this.state.configuration
                .categoryConfiguration[0].categoryConfigurationDetail,
            });
          }

          this.setState({ loading: false });
        } else {
          this.props.history.push({
            pathname: generatePath(this.props.match.path, {
              slug: this.props.match.params.slug,
              page: this.state.currentPage,
            }),
          });
          this.setState({ loading: true });

          const slug = this.props.match.params.slug;
          this.setState({ groupCallFlag: false });

          const res = await this.props.retreiveBrandBySlug(
            slug,
            this.state.currentPage
          );
          const test = await this.flagStateUpdater();
          this.setState({
            products: res.data[0].products[0].paginatedResults,
          });

          this.setState({
            configuration: res.data[0].configuration[0],
          });
          if (this.state.configuration) {
            this.setState({
              catagoryConfigurationDetails: this.state.configuration
                .categoryConfiguration[0].categoryConfigurationDetail,
            });
          }

          this.setState({ loading: false });
        }
      }
    );
  };

  render() {
    const {
      products,
      brandInfo,
      storeInfo,
      loading,
      configuration,
    } = this.state;

    const { quickView, currentPage, dataPerPage, affirm } = this.state;

    // Logic for displaying todos
    const indexOfLastTodo = currentPage * dataPerPage;
    const indexOfFirstTodo = indexOfLastTodo - dataPerPage;
    const currentTodos =
      products && products.slice(indexOfFirstTodo, indexOfLastTodo);

    // Logic for displaying page numbers
    const pageNumbers = [];
    for (
      let i = 1;
      i <= Math.ceil(products && products.length / dataPerPage);
      i++
    ) {
      pageNumbers.push(i);
    }

    // const renderPageNumbers = pageNumbers.map((number) => {
    //   return (
    //     <ul style={{ display: "inline-block" }}>
    //       <li
    //         className={number === this.state.currentPage ? "active" : ""}
    //         key={number}
    //         id={number}
    //         style={{ listStyle: "none" }}
    //       >
    //         {/* {number === this.state.currentPage ? ( */}
    //         <button
    //           id={number}
    //           className="btn btn-primary pagi-button"
    //           onClick={this.handleClick}
    //         >
    //           {number}
    //         </button>
    //       </li>
    //     </ul>
    //   );
    // });
    return (
      <Fragment>
        <ToastContainer
          enableMultiContainer
          containerId={"B"}
          position={toast.POSITION.TOP_RIGHT}
        />

        <div className="brandDetails-wrapper wrapper-90 max-1600">
          <BreadCrumb title={`Brand / ${this.props.match.params.slug}`} />
          <div className="brand-d-header">
            <div className="container-fluid my-5 brand-d-header-content">
              <div className="bd-header-content">
                <div className="bd-header-img col-md-5">
                  {this.state.loading ? (
                    <ContentLoader
                      speed={2}
                      width={544}
                      height={120}
                      viewBox="0 0 544 120"
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb"
                    >
                      <rect
                        x="6"
                        y="50"
                        rx="0"
                        ry="0"
                        width="544"
                        height="112"
                      />
                    </ContentLoader>
                  ) : null}
                  {storeInfo && storeInfo.storeLogo ? (
                    <img src={storeInfo.storeLogo} alt="Best image" />
                  ) : null}
                </div>
                <div className="bd-header-text-container col-md-7">
                  {this.state.loading ? (
                    <ContentLoader
                      speed={2}
                      width={476}
                      height={390}
                      viewBox="0 0 476 390"
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb"
                    >
                      <rect x="3" y="4" rx="3" ry="3" width="133" height="9" />
                      <rect x="4" y="25" rx="3" ry="3" width="52" height="6" />
                      <rect x="0" y="56" rx="3" ry="3" width="410" height="6" />
                      <rect x="0" y="72" rx="3" ry="3" width="380" height="6" />
                      <rect x="0" y="88" rx="3" ry="3" width="178" height="6" />
                      <rect
                        x="-1"
                        y="102"
                        rx="3"
                        ry="3"
                        width="410"
                        height="6"
                      />
                      <rect
                        x="-1"
                        y="118"
                        rx="3"
                        ry="3"
                        width="380"
                        height="6"
                      />
                      <rect
                        x="-1"
                        y="134"
                        rx="3"
                        ry="3"
                        width="178"
                        height="6"
                      />
                      <circle cx="21" cy="200" r="19" />
                      <circle cx="113" cy="199" r="19" />
                      <circle cx="207" cy="200" r="19" />
                      <circle cx="312" cy="198" r="19" />
                      <circle cx="401" cy="197" r="19" />
                      <rect
                        x="1"
                        y="244"
                        rx="0"
                        ry="0"
                        width="424"
                        height="41"
                      />
                    </ContentLoader>
                  ) : (
                    <Fragment>
                      <h3 className="bd-txt-title">{this.state.brandInfo}</h3>
                      <div className="bd-header-rating"></div>
                      <p className="bd-header-txt">
                        {storeInfo && storeInfo.storeMetaDescription}
                      </p>
                      <div className="brand-d-socialLinks">
                        <ul className="bd-links-list">
                          <li className="show-bd-ph">
                            <a
                              href={`tel:${storeInfo && storeInfo.storePhone}`}
                            >
                              <span className="bd-ph-no">
                                {storeInfo && storeInfo.storePhone}
                              </span>
                              <i className="fa fa-phone bd-social-icons" />
                            </a>
                          </li>
                          <li>
                            <a
                              target="_blank"
                              href={storeInfo && storeInfo.storeInstagram}
                            >
                              <i
                                className="fab fa-instagram bd-social-icons"
                                title="Instagram"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              target="_blank"
                              href={storeInfo && storeInfo.storeTwitter}
                            >
                              <i
                                className="fab fa-twitter bd-social-icons"
                                title="Twitter"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              target="_blank"
                              href={storeInfo && storeInfo.storePinterest}
                            >
                              <i
                                className="fab fa-pinterest bd-social-icons"
                                title="Pinterest"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              target="_blank"
                              href={storeInfo && storeInfo.storeWebsite}
                            >
                              <i
                                className="fa fa-globe bd-social-icons"
                                title="WebSite"
                              />
                            </a>
                          </li>
                        </ul>
                        <span className="bd-address">
                          {storeInfo && storeInfo.storeAddress} -{" "}
                          {storeInfo && storeInfo.storeCity} -{" "}
                          {storeInfo && storeInfo.storeCountry}
                        </span>
                      </div>
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/*HEADER*/}

          {/* PRODUCTS BODY */}
          <div className="container-fluid bd-products-container px-0 wrapper-90 max-1600">
            <div className="products-page">
              {this.state.groupFilters && this.state.groupFilters.length > 0 ? (
                <div className="products-dropdown-links">
                  <ul className="products-dropdown-list">
                    {/* PILE HEIGHT DROPDOWN */}
                    {this.state.finalFilters.map((item) => (
                      <li className="p-2 dropdown-titles">
                        <span className="p-2">{item.title}</span>
                        <i className="fa fa-angle-down" />

                        <ul className="products-dropdown-innerlist">
                          <div>
                            <div className="filter-design-sections">
                              {item.children &&
                                item.children.imageFilters.map(
                                  (item1, index) => (
                                    <li
                                      className="design-selection-item m-0"
                                      key={index}
                                    >
                                      <div className="select-to-filter-item">
                                        <ToggleButtonGroup
                                          value={this.state.selectedFilters}
                                          onChange={this.handleSelectedFilters}
                                        >
                                          <ToggleButton
                                            value={`${item1.title}`}
                                            aria-label={`${item1.title}`}
                                          >
                                            <img
                                              src={item1.image}
                                              className="img-fluid w-100"
                                              alt=""
                                            />

                                            <p>{item1.title}</p>
                                          </ToggleButton>
                                        </ToggleButtonGroup>
                                      </div>
                                    </li>
                                  )
                                )}
                            </div>
                          </div>
                          {item.children &&
                            item.children.nonImageFilters.map(
                              (item1, index) => (
                                <div className="d-flex align-items-center flex-row-reverse">
                                  <li
                                    key={index}
                                    className="inputLable-hovered f1"
                                  >
                                    <ToggleButtonGroup
                                      value={this.state.selectedFilters}
                                      onChange={this.handleSelectedFilters}
                                    >
                                      <ToggleButton
                                        value={`${item1.title}`}
                                        aria-label={`${item1.title}`}
                                        className="w-100"
                                      >
                                        <label
                                          className="m-0 w-100 c-pointer"
                                          htmlFor={`filterSelect${index}`}
                                        >
                                          <p>{item1.title}</p>
                                        </label>
                                      </ToggleButton>
                                    </ToggleButtonGroup>
                                  </li>
                                  <div className="p-2 filter-input">
                                    <input
                                      type="checkbox"
                                      id={`filterSelect${index}`}
                                    />
                                  </div>
                                </div>
                              )
                            )}
                        </ul>
                      </li>
                    ))}

                    {/*RUG SHAPE DROPDOWN */}

                    <li
                      className="dropdown-titles call-us-btn"
                      style={{ width: "150px", textAlign: "center" }}
                      onClick={() =>
                        this.setState({ filterProducts: this.state.products })
                      }
                    >
                      Clear Filter
                    </li>

                    <li
                      className="sort-filter-btn d-flex align-items-center p-2"
                      onClick={this.toggleDrawer("anchor", true)}
                    >
                      <span>Sort & Filter</span>
                    </li>

                    <Drawer
                      anchor={"right"}
                      open={this.state.rightSidebar}
                      onClose={this.toggleDrawer("right", false)}
                    >
                      <div className="productFilterSidebar">
                        <div className="sidebar-header">
                          <div
                            title="close"
                            className="closeSidebar"
                            onClick={this.toggleDrawer("right", false)}
                          >
                            <button type="button" className="close-sidebar-btn">
                              <svg
                                focusable="false"
                                viewBox="0 0 28 28"
                                class="closeSide-icon"
                                aria-hidden="true"
                                data-hb-id="pl-icon"
                              >
                                <path d="M15.4 14l3.3-3.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0L14 12.6l-3.3-3.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.3 3.3-3.3 3.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l3.3-3.3 3.3 3.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L15.4 14z"></path>
                              </svg>
                            </button>
                          </div>
                          <div className="sidebar-header-text">
                            <span>Sort & Filtre</span>
                          </div>
                        </div>
                        <div className="sidebarBody-inner">
                          <dropdowns.Dropdown
                            dropdownLable="Weights & Dimensions"
                            dropdownSubtitle={this.state.subTitle}
                          >
                            <div className="filter-dropDown-body">
                              Lorem ipsum dolor sit, amet consectetur
                              adipisicing elit. Facere nobis officiis odio!
                            </div>
                          </dropdowns.Dropdown>
                        </div>
                      </div>
                    </Drawer>

                    {/*END Rug Shape DROPDOWN  */}
                  </ul>
                </div>
              ) : null}
              <div className="bd-product-heading">
                <h2 className="brand-d-products-title">
                  {loading ? (
                    <ContentLoader
                      speed={2}
                      width={340}
                      height={84}
                      viewBox="0 0 340 84"
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb"
                    >
                      <rect
                        x="120"
                        y="34"
                        rx="3"
                        ry="3"
                        width="53"
                        height="11"
                      />
                      <rect
                        x="180"
                        y="34"
                        rx="3"
                        ry="3"
                        width="72"
                        height="11"
                      />
                      <rect
                        x="11"
                        y="34"
                        rx="3"
                        ry="3"
                        width="100"
                        height="11"
                      />
                      <rect
                        x="11"
                        y="9"
                        rx="3"
                        ry="3"
                        width="140"
                        height="11"
                      />
                      <rect
                        x="159"
                        y="9"
                        rx="3"
                        ry="3"
                        width="173"
                        height="11"
                      />
                    </ContentLoader>
                  ) : (
                    <Fragment>{this.state.brandInfo}'s products</Fragment>
                  )}
                </h2>
              </div>
              <div className="products-body pt-0">
                <div className="container-fluid">
                  <div className="products-items">
                    {/* FIRST ROW */}
                    {products && products === 0 ? (
                      <h5>No Product Found</h5>
                    ) : null}

                    {loading ? (
                      this.productsLoader(20)
                    ) : (
                      <div className="row">
                        {products &&
                          products.map((item) => (
                            <SingleProduct
                              item={item}
                              groupLoading={this.state.groupLoading}
                              loading={this.state.loading}
                              configuration={this.state.configuration}
                              catagoryConfigurationDetails={
                                this.state.configuration &&
                                this.state.configuration
                                  .categoryConfiguration[0]
                                  .categoryConfigurationDetail
                              }
                              slug={this.props.match.params.slug}
                              brand={true}
                            />
                          ))}
                      </div>
                    )}

                    <div className="container text-center">
                      <MemoryRouter
                        initialEntries={["/inbox"]}
                        initialIndex={0}
                      >
                        <Route>
                          {({ location }) => {
                            return (
                              <Pagination
                                page={
                                  this.state.currentPage &&
                                  this.state.currentPage
                                }
                                count={this.state.count}
                                renderItem={(item) => (
                                  <PaginationItem
                                    {...item}
                                    onClick={(e) => this.handleClick(item)}
                                  />
                                )}
                              />
                            );
                          }}
                        </Route>
                      </MemoryRouter>{" "}
                    </div>
                  </div>
                  {/*product item*/}
                </div>
                {/*Container fluid*/}
              </div>
              {/*product body*/}
            </div>
          </div>
          {/*products-page*/}
          {/* PRODUCTS BODY */}
          <Modal
            show={this.state.show}
            onHide={this.handleClose}
            animation={false}
            style={{ marginTop: "2%", boxShadow: "none" }}
          >
            <Modal.Body>
              {this.state.show && this.state.show === true && quickView ? (
                <div className="container-fluid">
                  <div className="row">
                    <div
                      className="modal-close"
                      onClick={this.handleClose}
                      data-dismiss="modal"
                    >
                      <Button
                        className="btn btn-defaul"
                        onClick={this.handleClose}
                      >
                        ×
                      </Button>
                    </div>
                    <div className="col-md-6">
                      <div className="modal-left-side">
                        <div className="moda-left-heading">
                          <h2>{quickView && quickView.title}</h2>
                        </div>
                        <div className="modal-seemore">
                          See More from
                          <a href="#">{this.state.brand && this.state.brand}</a>
                          Shop
                        </div>
                        <div className="modal-reviews">
                          <ul id="modal-stars">
                            <StarRatings
                              rating={
                                quickView && quickView.reviews
                                  ? quickView.reviews / quickView.reviewCount
                                  : 0
                              }
                              starDimension="20px"
                              starSpacing="2px"
                              starRatedColor="gold"
                            />
                            <span>{quickView && quickView.reviewCount}</span>
                          </ul>
                        </div>
                        <div className="modal-slider">
                          <CarouselProvider
                            visibleSlides={1}
                            totalSlides={quickView && quickView.images.length}
                            step={1}
                            naturalSlideWidth={400}
                            naturalSlideHeight={400}
                            hasMasterSpinner
                          >
                            <Slider>
                              {quickView &&
                                quickView.images &&
                                quickView.images.map((item, index) => (
                                  <Slide index={index}>
                                    <ImageWithZoom src={item} />
                                  </Slide>
                                ))}
                            </Slider>

                            <DotGroup />
                          </CarouselProvider>
                        </div>
                      </div>
                      {/*END MODAL LEFT SIDE*/}
                    </div>
                    <div
                      className="col-md-6"
                      style={{ backgroundColor: "hsla(240,5%,96%,.85)" }}
                    >
                      <div className="moda-right-side">
                        <div className="modal-right-price">
                          <span className="m-price">
                            $
                            {quickView.enableSale === true
                              ? Number(
                                  quickView.price -
                                    (quickView.price * quickView.saleDiscount) /
                                      100
                                ).toFixed(2) * this.state.quantity
                              : Number(quickView.price).toFixed(2) *
                                this.state.quantity}
                          </span>
                          <span>
                            {quickView.enableSale === true ? (
                              <del className="moda-right-price-off">
                                ${Number(quickView.price).toFixed(2)}
                              </del>
                            ) : null}
                          </span>
                        </div>
                        <div className="modal-shiping-dete">
                          <span>FREE Shipping</span>
                          <span>Get it Now</span>
                        </div>

                        <div className="modal-right-collapse">
                          <div className="accordion" id="accordion">
                            <div className="card mt-3">
                              <div className="checkout-inps">
                                <span className="selectcountry-hint">
                                  Select Quantity
                                </span>
                                <select
                                  className="countrySelect"
                                  onChange={(e) => {
                                    this.setState({
                                      quantity: e.target.value,
                                    });
                                  }}
                                >
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                  <option value="6">6</option>
                                  <option value="7">7</option>
                                  <option value="8">8</option>
                                  <option value="9">9</option>
                                  <option value="10">10</option>
                                </select>
                              </div>
                            </div>
                            <div className="card mt-3">
                              <div
                                id="product-description"
                                className="collapse-heading"
                              >
                                <button
                                  className="btn btn-link collapsed py-md-3"
                                  type="button"
                                  data-toggle="collapse"
                                  data-target="#description-collapse"
                                  aria-expanded="false"
                                  aria-controls="description-collapse"
                                >
                                  Description
                                  <span>
                                    <i className="fa fa-angle-down" />
                                  </span>
                                </button>
                              </div>
                              <div
                                id="description-collapse"
                                className="collapse"
                                aria-labelledby="product1description"
                                data-parent="#accordion"
                              >
                                <div className="card-body">
                                  <div className="description-body">
                                    <div className="description-content">
                                      <p>
                                        {quickView && quickView.description}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card mt-3">
                              <div
                                id="product-weights-dimention"
                                className="collapse-heading"
                              >
                                <button
                                  className="btn btn-link collapsed py-md-3"
                                  type="button"
                                  data-toggle="collapse"
                                  data-target="#weights-dimention-collapse"
                                  aria-expanded="false"
                                  aria-controls="weights-dimention-collapse"
                                >
                                  Weights & Dimensions
                                  <span>
                                    <i className="fa fa-angle-down" />
                                  </span>
                                </button>
                              </div>
                              <div
                                id="weights-dimention-collapse"
                                className="collapse"
                                aria-labelledby="product1weights-dimention"
                                data-parent="#accordion"
                              >
                                <div className="card-body">
                                  <div className="weights-dimension-content">
                                    {quickView &&
                                      quickView.weightAndDimension &&
                                      quickView.weightAndDimension.weightAndDimension.map(
                                        (e, index) => (
                                          <Fragment key={index}>
                                            {JSON.parse(e).value &&
                                            JSON.parse(e).value !== "" ? (
                                              <Fragment>
                                                <p className="dimension-heading">
                                                  {JSON.parse(e).name}
                                                </p>
                                                <div className="product-weight">
                                                  <div className="overall-weight">
                                                    <p className="m-0 py-2">
                                                      {JSON.parse(e).name}
                                                    </p>
                                                  </div>
                                                  <p className="m-0 py-2">
                                                    {JSON.parse(e).value}
                                                  </p>
                                                </div>
                                              </Fragment>
                                            ) : null}
                                          </Fragment>
                                        )
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card mt-3">
                              <div
                                id="product-spesification"
                                className="collapse-heading"
                              >
                                <button
                                  className="btn btn-link collapsed py-md-3"
                                  type="button"
                                  data-toggle="collapse"
                                  data-target="#spesification-collapse"
                                  aria-expanded="false"
                                  aria-controls="spesification-collapse"
                                >
                                  Specifications
                                  <span>
                                    <i className="fa fa-angle-down" />
                                  </span>
                                </button>
                              </div>
                              <div
                                id="spesification-collapse"
                                className="collapse"
                                aria-labelledby="product1spesification"
                                data-parent="#accordion"
                              >
                                <div className="card-body">
                                  <div className="spesification-content">
                                    {quickView &&
                                      quickView.specification &&
                                      quickView.specification.specification.map(
                                        (e, index) => (
                                          <div
                                            key={index}
                                            className="product-weight"
                                          >
                                            {" "}
                                            {JSON.parse(e).value &&
                                            JSON.parse(e).value !== "" ? (
                                              <Fragment>
                                                <div className="overall-weight">
                                                  <p className="m-0 py-2">
                                                    {JSON.parse(e).name}
                                                  </p>
                                                </div>
                                                <p className="m-0 py-2">
                                                  {JSON.parse(e).value}
                                                </p>
                                              </Fragment>
                                            ) : null}
                                          </div>
                                        )
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="modal-end-btns">
                              <button
                                type="button"
                                className="modal-add-cart"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this._addToCart(quickView && quickView);
                                }}
                              >
                                <span>Add To Cart</span>
                              </button>
                              <button
                                type="button"
                                className="modal-save-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this._addToWishlist(quickView && quickView);
                                }}
                              >
                                <span>
                                  <i className="far fa-heart" /> Save
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                "<div></div>"
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Fragment>
    );
  }
}

sellerProducts.prototype = {
  sellerProducts: PropTypes.func.isRequired,
};
retreiveBrandBySlug.prototype = {
  retreiveBrandBySlug: PropTypes.func.isRequired,
};
cartAdd.propTypes = {
  cartAdd: PropTypes.func.isRequired,
};
getGroups.propTypes = {
  getGroups: PropTypes.func.isRequired,
};
getBrandFilteredProduct.propTypes = {
  getBrandFilteredProduct: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default withRouter(
  connect(mapStateToProps, {
    sellerProducts,
    retreiveBrandBySlug,
    cartAdd,
    getGroups,
    getBrandFilteredProduct,
  })(BrandDetail)
);
